<template>
  <div class="ellipsis-tooltip" :title="text">
    {{ (truncatedText != 'null' ? truncatedText : '-') ?? '-' }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  text: string;
  limit?: number;
}

const props = withDefaults(defineProps<Props>(), {
  text: '',
  limit: 40,
});

const truncatedText = computed(() => {
  return props.text.length > (props.limit ?? 40) ? props.text.slice(0, props.limit) + '...' : props.text;
});
</script>

<style scoped>
.ellipsis-tooltip {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  cursor: pointer;
}
</style>
